var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacBasementType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 1e3 1e3",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004c3f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m797.75 676.42h-595.5a16 16 0 0 1-16-16v-353.24a16 16 0 0 1 32 0v337.24h563.5v-337.24a16 16 0 0 1 32 0v353.24a16 16 0 0 1-16 16z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m202.25 916a16 16 0 0 1-16-16v-240.07a16 16 0 0 1 32 0v240.07a16 16 0 0 1-16 16z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m561.46 676.42h-122.92a16 16 0 0 1-16-16v-189.93a16 16 0 0 1 16-16h122.92a16 16 0 0 1 16 16v189.93a16 16 0 0 1-16 16zm-106.92-32h90.92v-157.93h-90.92z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m500 389.49a56.52 56.52 0 1 1 56.52-56.49 56.58 56.58 0 0 1-56.52 56.49zm0-81a24.52 24.52 0 1 0 24.52 24.51 24.55 24.55 0 0 0-24.52-24.55z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m357.77 573.73h-74.54a16 16 0 0 1-16-16v-114.24a16 16 0 0 1 16-16h74.54a16 16 0 0 1 16 16v114.24a16 16 0 0 1-16 16zm-58.54-32h42.54v-82.24h-42.54z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m716.77 573.73h-74.54a16 16 0 0 1-16-16v-114.24a16 16 0 0 1 16-16h74.54a16 16 0 0 1 16 16v114.24a16 16 0 0 1-16 16zm-58.54-32h42.54v-82.24h-42.54z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m900 362.93a16.19 16.19 0 0 1-5.8-1.08l-394.2-153.26-394.2 153.26a16 16 0 0 1-21.8-14.92v-91.43a16 16 0 0 1 10.2-14.91l400-155.5a16 16 0 0 1 11.6 0l400 155.5a16 16 0 0 1 10.2 14.91v91.43a16 16 0 0 1-16 16zm-400-187.5a16.11 16.11 0 0 1 5.8 1.08l378.2 147v-57.1l-384-149.24-384 149.28v57.1l378.2-147a16.11 16.11 0 0 1 5.8-1.12z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m269.74 807.57a16 16 0 0 1-16-16v-38.4h-51.49a16 16 0 0 1 0-32h67.49a16 16 0 0 1 16 16v54.4a16 16 0 0 1-16 16z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m324.14 862a16 16 0 0 1-16-16v-38.43h-38.4a16 16 0 1 1 0-32h54.4a16 16 0 0 1 16 16v54.43a16 16 0 0 1-16 16z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m378.54 916a16 16 0 0 1-16-16v-38h-38.4a16 16 0 1 1 0-32h54.4a16 16 0 0 1 16 16v54a16 16 0 0 1-16 16z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m797.75 916h-595.5a16 16 0 0 1 0-32h579.5v-224a16 16 0 0 1 32 0v240a16 16 0 0 1-16 16z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacBasementType1);
export default __webpack_public_path__ + "static/media/fac_basement_type_1.b3cd45e2617e0bdd7a432776415de127.svg";
export { ForwardRef as ReactComponent };